import {
  CommodityConnectionType,
  CommodityFilterByTerm,
  CommodityFilterStatusFlag,
  CommoditySortByTerm,
  SortOrder,
} from '@bechtel/types';
import { t } from '@lingui/macro';
import { DrawerSearchScope, WeldDrawerValuesProps } from './types';

export const drawerValues: WeldDrawerValuesProps = {
  searchByList: [CommodityFilterByTerm.TAG_NUMBER],
  searchScope: DrawerSearchScope.ASSIGNED_TO_ME,
  sortBy: CommoditySortByTerm.TAG,
  sortDir: SortOrder.DESC,
  isPriority: false,
  weldTypes: [],
  weldStatusList: [],
  weldSizeList: [],
};

export const searchByList = [
  { id: 0, value: CommodityFilterByTerm.TAG_NUMBER, label: t`Weld ID` },
  { id: 1, value: CommodityFilterByTerm.AREA_NUMBER, label: t`Area Number` },
  { id: 2, value: CommodityFilterByTerm.DRAWING_NUMBER, label: t`Drawing Number` },
  { id: 3, value: CommodityFilterByTerm.STARTUP_SYSTEM_NUMBER, label: t`Startup System Number` },
  { id: 4, value: CommodityFilterByTerm.TEST_WORK_PACKAGE_NUMBER, label: t`Test Package` },
  { id: 5, value: CommodityFilterByTerm.WORK_PACKAGE_NUMBER, label: t`Work Package Number` },
  { id: 6, value: CommodityFilterByTerm.WELD_PROCEDURE_ID, label: t`WPS` },
  { id: 7, value: CommodityFilterByTerm.MATERIAL_TYPE, label: t`Material (P Number)` },
  { id: 8, value: CommodityFilterByTerm.CREW_MEMBER_NAME, label: t`User Name` },
];

export const sortByList = [
  { id: 1, value: CommoditySortByTerm.TEST_WP_NUMBER, label: t`Test Package` },
  // { id: 2, value: CommoditySortByTerm.TRANSACTION_DATE, label: t`Transaction Date` },
  { id: 3, value: CommoditySortByTerm.TAG, label: t`Weld Tag` },
  { id: 4, value: CommoditySortByTerm.WP_NUMBER, label: t`Work Package Number` },
  { id: 5, value: CommoditySortByTerm.ACTIVITY_DATE, label: t`Activity Date` },
];

export const weldTypes = [
  { id: 1, value: CommodityConnectionType.PIPE, label: t`Pipe` },
  { id: 2, value: CommodityConnectionType.HANGERS, label: t`Hanger` },
  { id: 3, value: CommodityConnectionType.STRUCTURAL, label: t`Structural` },
  { id: 4, value: CommodityConnectionType.TANKS, label: t`Tanks` },
];

export const searchScopeList = [
  { id: 1, value: DrawerSearchScope.ASSIGNED_TO_ME, label: t`Assigned to Me` },
  { id: 2, value: DrawerSearchScope.UNASSIGNED, label: t`Unassigned` },
  { id: 3, value: DrawerSearchScope.ALL, label: t`All Welds` },
];

export const weldStatusList = [
  { id: 1, value: CommodityFilterStatusFlag.FITUP_INSPECTION, label: t`Fitup Inspection` },
  { id: 2, value: CommodityFilterStatusFlag.READY_TO_WELD, label: t`Ready to Weld` },
  { id: 3, value: CommodityFilterStatusFlag.CLAIMED, label: t`Claimed` },
  { id: 4, value: CommodityFilterStatusFlag.VT_APPROVED, label: t`VT Approved` },
  { id: 5, value: CommodityFilterStatusFlag.VT_SENT_BACK, label: t`VT Sent Back` },
  { id: 6, value: CommodityFilterStatusFlag.SENT_BACK_TO_PIPING, label: t`Sent Back to Piping` },
  { id: 7, value: CommodityFilterStatusFlag.BLOCKED, label: t`Blocked` },
];

// hidden from the status filter when the project has TWX enabled (ArcStryker)
export const TWX_HIDDEN_WELD_STATUSES = [
  CommodityFilterStatusFlag.FITUP_INSPECTION,
  CommodityFilterStatusFlag.SENT_BACK_TO_PIPING,
];

export const getVisibleWeldStatusList = (twxEnabled: boolean) =>
  twxEnabled ? weldStatusList.filter((item) => !TWX_HIDDEN_WELD_STATUSES.includes(item.value)) : weldStatusList;

export const weldSizeList = [
  { id: 1, value: CommodityFilterByTerm.SMALL_BORE, label: t`Small Bore (Less than 2.5 inch)` },
  { id: 2, value: CommodityFilterByTerm.LARGE_BORE, label: t`Large Bore (Greater than 2.5 inch)` },
];
